module.exports = __webpack_public_path__ + "static/media/login-signup-logo.e56b8419.png";